import { getProvider } from '@/apollo'
import gql from 'graphql-tag'
import { splitError } from '@/helper/splitError'

const PersonalDataModule = {
  namespaced: true,
  state: {
    customer: {
      alternativePhone: ''
    },
    numberChanged: false
  },
  actions: {
    async changePersonalData ({ dispatch, commit, state, getters }, newCustomer) {
      const apolloClient = getProvider().defaultClient
      commit('clearMessages', {}, { root: true })

      let phoneNumber = newCustomer.alternativePhone ? newCustomer.alternativePhone : ''
      phoneNumber = phoneNumber.replace(/([^0-9])/g, '').trim() // remove any character that is NOT a digit
      // magma only accept 49 or 0, but NOT 049, 0049 or 00 => remove leading zero
      phoneNumber = phoneNumber.replace(/^00/, '0')
      phoneNumber = phoneNumber.replace(/^049/, '49')

      // You have to ask yourself why we have an api, if we have to manually check such things...
      if (getters.phoneNumberFormatted !== phoneNumber) {
        commit('setAlternativePhone', newCustomer.alternativePhone)
      }

      phoneNumber = ''
      if (getters.phoneNumberFormatted !== '' || this.numberChanged) {
        phoneNumber = getters.phoneNumberFormatted
      }

      return apolloClient.mutate({
        mutation: gql`mutation changeContact ($changeContactInput: ChangeContactInput!) {
          changeContact(changeContact: $changeContactInput) {
           phoneNumber,
           email,
           address,
           addressCorrected
          }
        }`,
        variables: {
          changeContactInput: {
            phoneNumber: phoneNumber,
            email: newCustomer.email,
            address: {
              city: newCustomer.address.city,
              houseNumber: newCustomer.address.houseNumber,
              street: newCustomer.address.street,
              supplement: newCustomer.address.supplement,
              zip: newCustomer.address.zip
            }
          }
        }
      }).then((response) => {
        commit('Transaction/removeTransactionId', 'personalData', { root: true })
        return 'success'
      }).catch((error) => {
        splitError(error).forEach(e => commit('addError', e, { root: true }))
        return 'error'
      })
    }
  },
  getters: {
    phoneNumberFormatted: state => {
      let phoneNumber = state.customer?.alternativePhone || ''
      phoneNumber = phoneNumber.replace(/([^0-9])/g, '').trim() // remove any character that is NOT a digit
      // magma only accept 49 or 0, but NOT 049, 0049 or 00 => remove leading zero
      phoneNumber = phoneNumber.replace(/^00/, '0')
      phoneNumber = phoneNumber.replace(/^049/, '49')

      return phoneNumber
    },
    numberChanged: state => {
      return state.numberChanged
    }
  },
  mutations: {
    setAlternativePhone: (state, alternativePhone) => {
      state.customer.alternativePhone = alternativePhone
      state.numberChanged = true
    }
  }
}

export {
  PersonalDataModule
}
